import React, { useEffect, useContext } from "react";
import { DataContext } from "../context/DataContext";



const Cleanser = () => {
    const {
        setStateCleanser
      } = useContext(DataContext);
    
    useEffect(() => {
        setStateCleanser(false)
    }, [])

    return (
        <>
        </>
    )
}
export default Cleanser;